import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Users/Flex/Documents/Workspace/react-type-check/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "api-reference"
    }}>{`API Reference`}</h1>
    <h2 {...{
      "id": "isfunctioncomponent"
    }}>{`isFunctionComponent`}</h2>
    <p>{`Determines if the passed value is a React function component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import React from 'react';
import { isFunctionComponent } from 'react-type-check';

let maybeFC: React.FC | string = () => <div>I'm a function component!</div>;
if (Math.random() > 0.5) {
  maybeFC = 'Not FC';
}
if (isFunctionComponent(maybeFC)) {
  const fc: React.FC = maybeFC;
} else {
  const notFC: string = maybeFC;
}
`}</code></pre>
    <h2 {...{
      "id": "isclasscomponent"
    }}>{`isClassComponent`}</h2>
    <p>{`Determines if the passed value is a React class component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import React from 'react';
import { isClassComponent } from 'react-type-check';

class ClassComponent extends React.Component {
  render() {
    return <div>I'm a class component!</div>;
  }
}
let maybeCC: React.ComponentClass | string = ClassComponent;
if (Math.random() > 0.5) {
  maybeCC = 'Not CC';
}
if (isClassComponent(maybeCC)) {
  const cc: React.ComponentClass = maybeCC;
} else {
  const notCC: string = maybeCC;
}
`}</code></pre>
    <h2 {...{
      "id": "ismemoizedcomponent"
    }}>{`isMemoizedComponent`}</h2>
    <p>{`Determines if the passed value is a React.memo() memoized component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import React from 'react';
import { isMemoizedComponent } from 'react-type-check';

let maybeMC:
  | React.MemoExoticComponent<React.ComponentType>
  | string = React.memo(() => <div>I'm a memoized component!</div>);
if (Math.random() > 0.5) {
  maybeMC = 'Not MC';
}
if (isMemoizedComponent(maybeMC)) {
  const mc: React.MemoExoticComponent<React.ComponentType> = maybeMC;
} else {
  const notMC: string = maybeMC;
}
`}</code></pre>
    <h2 {...{
      "id": "isreactcomponent"
    }}>{`isReactComponent`}</h2>
    <p>{`Determines if the passed value is a React class component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import React from 'react';
import { isReactComponent } from 'react-type-check';

let maybeRC: React.ComponentType | string = () => <div>I'm some React component!</div>;
if (Math.random() > 0.5) {
  maybeRC = 'Not RC';
}
if (isReactComponent(maybeRC)) {
  const rc: React.ComponentType = maybeRC;
} else {
  const notRC: string = maybeRC;
}

`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      